/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';

// #endregion Local Imports

const pathname = '/areas';

export const AreaApi = {
  createImport: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/import`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (option?: CheckDuplicateAreaCodeQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateCode: async () => {
    const url = `${pathname}/generate-code`;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface AreaType {
  id: string;
  wardID?: string;
  ownerID?: string;
  entityID?: string;
  shortID?: string;
  code?: string;
  totalArea?: number;
  totalQuantity?: number;
  avatar?: string;
  totalProductObject?: number;
  name?: string;
  type?: number;
}

export interface CheckDuplicateAreaCodeQuery {
  code: string;
}

export interface GenerateAreaCodeQuery {
  entityID?: string;
}
